import { render, staticRenderFns } from "./LevantamientosStatistics.vue?vue&type=template&id=009dd8a4&scoped=true"
import script from "./LevantamientosStatistics.vue?vue&type=script&lang=ts"
export * from "./LevantamientosStatistics.vue?vue&type=script&lang=ts"
import style0 from "./LevantamientosStatistics.vue?vue&type=style&index=0&id=009dd8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009dd8a4",
  null
  
)

export default component.exports